"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const mongoose = tslib_1.__importStar(require("mongoose"));
const variableSchema = new mongoose.Schema({
    key: { type: String, index: true, unique: true },
    name: { type: String, index: true },
    label: String,
    concept: { type: String, index: true },
    predicateType: String,
    limit: String,
    start: Number,
    end: Number,
    unit: String,
    properties: { type: [String] },
    baseUrl: String,
    year: { type: String, index: true },
    level: String
});
const v1VariableModel = mongoose.model('Variable', variableSchema);
exports.v1VariableModel = v1VariableModel;
//# sourceMappingURL=Variable.model.js.map